import { AxiosInstance } from 'axios'
import { InjectionKey } from '@vue/composition-api'
import { validateVoid } from './api.zod'
import { axiosApiResponse } from './api.axios'
import { ApiResponse } from './responses'

export type VideoSide = 'left' | 'right'

export class IngestionApi {
  constructor(private client: AxiosInstance, private uri: string) {}

  private path(path: string): string {
    return this.uri + path
  }

  SwapVideoSpeakers(
    conversationId: ConversationId,
    side: VideoSide
  ): ApiResponse<void> {
    return handleVoidResponse(
      this.client.put(this.path(`/analysis/${conversationId}/${side}`))
    )
  }
}

export const IngestionApiKey: InjectionKey<IngestionApi> = Symbol()

export type ConversationId = string | number

export const handleVoidResponse = axiosApiResponse(validateVoid)
